module.exports = __webpack_public_path__ + "media/images/mediator_top_muji-6d81ed9e403cfbfc20090d55af492dd7.jpg";